import { render, staticRenderFns } from "./IndexReportAdmin.vue?vue&type=template&id=c2d653f6&scoped=true&lang=pug&"
import script from "./IndexReportAdmin.vue?vue&type=script&lang=ts&"
export * from "./IndexReportAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./IndexReportAdmin.vue?vue&type=style&index=0&id=c2d653f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d653f6",
  null
  
)

export default component.exports